import { render, staticRenderFns } from "./test_record.vue?vue&type=template&id=4443212e&scoped=true&"
import script from "./test_record.vue?vue&type=script&lang=js&"
export * from "./test_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443212e",
  null
  
)

export default component.exports